import React, { useState, useEffect } from "react";
import {
  FaChevronLeft,
  FaChevronRight,
  FaEye,
  FaEyeSlash,
} from "react-icons/fa";
import {
  getButtonCollapsedMemory,
  getMenuCollapsedMemory,
  setButtonCollapsedmemory,
  setMenuCollapsedmemory,
} from "../data/memory";
import { changePassword } from "../data/userService";
import { useWindowSize } from "../componets/useWindowSize";
import Menu from "../componets/Menu";
import AlertSuccess from "../componets/AlerSuccess";
import AlertError from "../componets/AlertError";
import AlertPerigo from "../componets/AlertPerigo";

import {
  EmailAuthProvider,
  getAuth,
  reauthenticateWithCredential,
} from "firebase/auth";
import { getDatabase, ref, update, onValue } from "firebase/database";
import { resetList } from "../data/resetList";
import { autoResetJogosMensal } from "../data/autoClear";
import { deleteAccount } from "../firebase/AuthService";

const Configuracoes: React.FC = () => {
  const { width } = useWindowSize();
  const [isMenuCollapsed, setIsMenuCollapsed] = useState(
    getMenuCollapsedMemory()
  );
  const [isButtonCollapsed, setIsButtonCollapsed] = useState(
    getButtonCollapsedMemory()
  );

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordCheck, setNewPasswordCheck] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [birthday, setBirthday] = useState("");
  const [passwordToDelete, setPasswordToDelete] = useState("");

  const [loading, setLoading] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const [successAlert, setSuccessAlert] = useState({
    open: false,
    message: "",
  });
  const [errorAlert, setErrorAlert] = useState({ open: false, message: "" });

  useEffect(() => {
    resetList();
    autoResetJogosMensal();
  }, []);

  useEffect(() => {
    if (width < 1000) {
      setIsMenuCollapsed(true);
      setMenuCollapsedmemory(true);
    } else {
      if (!getButtonCollapsedMemory()) {
        setIsMenuCollapsed(false);
        setMenuCollapsedmemory(false);
      }
    }
  }, [width]);

  const handleMenuToggle = () => {
    const newButtonCollapsedState = !isButtonCollapsed;
    const newMenuCollapsedState = !isMenuCollapsed;
    setIsButtonCollapsed(newButtonCollapsedState);
    setButtonCollapsedmemory(newButtonCollapsedState);
    setIsMenuCollapsed(newMenuCollapsedState);
    setMenuCollapsedmemory(newMenuCollapsedState);
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const handleVerifyPasswordBeforeDelete = async () => {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user || !passwordToDelete) {
      setErrorAlert({ open: true, message: "Digite a senha para continuar." });
      return;
    }

    const credential = EmailAuthProvider.credential(
      user.email || "",
      passwordToDelete
    );

    try {
      await reauthenticateWithCredential(user, credential);
      setIsDeleteModalOpen(true); // só abre o modal se a senha estiver correta
    } catch (error) {
      setErrorAlert({
        open: true,
        message: "Senha incorreta. Tente novamente.",
      });
    }
  };

  useEffect(() => {
    const auth = getAuth();
    const user = auth.currentUser;
    if (user) {
      const db = getDatabase();
      const userRef = ref(db, `users/${user.uid}`);
      onValue(userRef, (snapshot) => {
        const data = snapshot.val();
        if (data) {
          setDisplayName(data.displayName || "");
          setBirthday(data.aniversario || "");
        }
      });
    }
  }, []);

  const handleChangePassword = async () => {
    if (!oldPassword || !newPassword || !newPasswordCheck) {
      setErrorAlert({ open: true, message: "Preencha todos os campos." });
      return;
    }

    if (newPassword !== newPasswordCheck) {
      setErrorAlert({ open: true, message: "As senhas não coincidem." });
      return;
    }

    try {
      await changePassword(oldPassword, newPassword);
      setOldPassword("");
      setNewPassword("");
      setNewPasswordCheck("");
      setPasswordVisible(false);
      setSuccessAlert({ open: true, message: "Senha alterada com sucesso." });
    } catch {
      setErrorAlert({ open: true, message: "Senha antiga incorreta." });
    }
  };

  const handleUpdateUserInfo = async () => {
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) return;

    if (!displayName.trim()) {
      setErrorAlert({
        open: true,
        message: "O nome/apelido não pode ficar vazio.",
      });
      return;
    }
    setLoading(true);

    try {
      const db = getDatabase();
      const userRef = ref(db, `users/${user.uid}`);
      const presencaRef = ref(db, `presenca/${user.uid}`);

      const presencaSnapshot = await new Promise<any>((resolve) =>
        onValue(presencaRef, resolve, { onlyOnce: true })
      );

      if (presencaSnapshot.exists()) {
        await update(presencaRef, { displayName: displayName.trim() });
      }

      await update(userRef, {
        displayName: displayName.trim(),
        aniversario: birthday,
      });

      setSuccessAlert({
        open: true,
        message: "Informações atualizadas com sucesso.",
      });
    } catch (err) {
      setErrorAlert({ open: true, message: "Erro ao atualizar informações." });
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteAccount = async () => {
    try {
      console.log("Deletou SIM");
      await deleteAccount(passwordToDelete);
      // Redirecionar para login ou homepage após deletar
      window.location.href = "/login";
    } catch (error) {
      setErrorAlert({
        open: true,
        message: "Erro ao deletar conta. Verifique a senha.",
      });
    }
  };

  return (
    <main className="flex h-dvh bg-black">
      <AlertSuccess
        isOpen={successAlert.open}
        message={successAlert.message}
        onClose={() => setSuccessAlert({ open: false, message: "" })}
      />
      <AlertError
        isOpen={errorAlert.open}
        message={errorAlert.message}
        onClose={() => setErrorAlert({ open: false, message: "" })}
      />
      <AlertPerigo
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={handleDeleteAccount}
        message="Tem certeza que deseja deletar sua conta? Essa ação é irreversível."
      />

      <div
        className={`fixed top-0 left-0 flex h-full flex-col ${
          isMenuCollapsed ? "w-16" : "w-64"
        } bg-black text-white transition-all duration-300`}
      >
        <button className="p-4 text-white" onClick={handleMenuToggle}>
          {isMenuCollapsed ? <FaChevronRight /> : <FaChevronLeft />}
        </button>
        <div className="min-h-0 flex-1">
          <Menu isCollapsed={isMenuCollapsed} />
        </div>
      </div>

      <section
        className={`flex flex-col w-full h-full p-6 ${
          isMenuCollapsed ? "ml-16" : "ml-64"
        } transition-all duration-300 overflow-y-auto`}
      >
        <div className="flex flex-col items-center gap-10 py-12">
          {/* Atualizar informações */}
          <form className="flex flex-col w-full max-w-md p-6 rounded-2xl bg-gray-900 shadow-lg">
            <h1 className="text-xl font-bold text-white mb-4 text-center">
              Informações do Perfil
            </h1>
            <label className="text-white mb-1">Nome / Apelido</label>
            <input
              type="text"
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
              className="w-full p-2 rounded-md bg-gray-800 text-white border border-gray-600 focus:ring-2 focus:ring-pink-500 outline-none"
            />
            <label className="text-white mt-4 mb-1">Data de Aniversário</label>
            <input
              type="date"
              value={birthday}
              onChange={(e) => setBirthday(e.target.value)}
              className="w-full p-2 rounded-md bg-gray-800 text-white border border-gray-600 focus:ring-2 focus:ring-pink-500 outline-none"
            />
            <button
              type="button"
              onClick={handleUpdateUserInfo}
              disabled={loading}
              className="mt-6 p-2 bg-pink-600 hover:bg-pink-500 text-white font-bold rounded-md"
            >
              {loading ? "Salvando..." : "Salvar alterações"}
            </button>
          </form>

          {/* Alterar senha */}
          <form className="flex flex-col w-full max-w-md p-6 rounded-2xl bg-gray-900 shadow-lg">
            <h1 className="text-xl font-bold text-white mb-4 text-center">
              Alterar Senha
            </h1>
            <label className="text-white mb-1">Senha Atual</label>
            <input
              type="password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              className="w-full p-2 rounded-md bg-gray-800 text-white border border-gray-600 focus:ring-2 focus:ring-pink-500 outline-none"
            />
            <label className="text-white mt-4 mb-1">Nova Senha</label>
            <div className="relative">
              <input
                type={passwordVisible ? "text" : "password"}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="w-full p-2 rounded-md bg-gray-800 text-white border border-gray-600 focus:ring-2 focus:ring-pink-500 outline-none"
              />
              <button
                type="button"
                onClick={togglePasswordVisibility}
                className="absolute right-3 top-3 text-gray-400"
              >
                {passwordVisible ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
            <label className="text-white mt-4 mb-1">Confirmar Nova Senha</label>
            <input
              type={passwordVisible ? "text" : "password"}
              value={newPasswordCheck}
              onChange={(e) => setNewPasswordCheck(e.target.value)}
              className="w-full p-2 rounded-md bg-gray-800 text-white border border-gray-600 focus:ring-2 focus:ring-pink-500 outline-none"
            />
            <button
              type="button"
              onClick={handleChangePassword}
              className="mt-6 p-2 bg-pink-600 hover:bg-pink-500 text-white font-bold rounded-md"
            >
              Alterar Senha
            </button>
          </form>

          {/* Deletar conta */}
          <form className="flex flex-col w-full max-w-md p-6 rounded-2xl bg-gray-900 shadow-lg">
            <h1 className="text-xl font-bold text-white mb-4 text-center">
              Deletar Conta
            </h1>
            <label className="text-white mb-1">Senha</label>
            <input
              type="password"
              value={passwordToDelete}
              onChange={(e) => setPasswordToDelete(e.target.value)}
              className="w-full p-2 rounded-md bg-gray-800 text-white border border-gray-600 focus:ring-2 focus:ring-pink-500 outline-none"
            />
            <button
              type="button"
              onClick={handleVerifyPasswordBeforeDelete}
              className="mt-6 p-2 bg-red-600 hover:bg-red-500 text-white font-bold rounded-md"
            >
              Deletar Conta
            </button>
          </form>
        </div>
      </section>
    </main>
  );
};

export default Configuracoes;
